import { getVisitorIdCookie } from "@brandclub/common-ui";
import axios from "../../../utils/axios";
export * from "./AppConfig";
export * from "./AppInstallation";
export * from "./Product";
export * from "./Site";


export const getChallengeCodeForMagicLinkToken = async (token: string) => {
    const visitorId = getVisitorIdCookie() || Math.random().toString(36).substring(2, 15);
    const res = await axios.post(`/auth/generateChallengeCode`, {
        visitorToken: btoa(visitorId + token),
    }, {
        headers: {
            "x-bc-visitor-id": visitorId,
        },
    });
    return res?.data as {
        status: "success" | "error";
        phoneNumber?: string;
        challengeCode?: string;
        errorMessage?: string;
    };

};